<template class="multi-select">

    <span id="selectwrapper">
        <!-- 培训类别：trainType -->
        <el-form-item :label="$t('c.trainingType')" v-if="nameArrays.findIndex((n) => n.key == 'trainType')>-1">
            <el-select v-model="trainType.selectVal" multiple collapse-tags :placeholder="$t('tip.select')">
                <el-option :label="$t('c.all')" :value="0"></el-option>
                <el-option :label="item.value" :value="item.id" :key="item.id"
                        v-for="item in trainTypeMenu"></el-option>
            </el-select>
        </el-form-item>

        <!--培训模式：线上、线下
            注意：因为值中有0，在active中对id+1，在组件中要-1后再发请求
        -->
        <el-form-item :label="$t('train.trainingMode')" v-if="nameArrays.findIndex((n) => n.key == 'trainMode')>-1">
            <el-select v-model="trainMode.selectVal" multiple collapse-tags :placeholder="$t('tip.select')">
                <el-option :label="$t('c.all')" :value="0"></el-option>
                <el-option :label="item.value" :value="item.id" :key="item.id"
                        v-for="item in trainModeMenu"></el-option>
            </el-select>
        </el-form-item>
        <!-- 项目类型 projectTypes -->
        <el-form-item :label="$t('system.projectType')" v-if="nameArrays.findIndex((n) => n.key == 'projectType')>-1">
            <el-select v-model="projectType.selectVal" multiple collapse-tags :placeholder="$t('tip.select')">
                <el-option :label="$t('c.all')" :value="0"></el-option>
                <el-option :label="item.value" :value="item.id" :key="item.id"
                        v-for="item in projectTypeMenu"></el-option>
            </el-select>
        </el-form-item>
        <!-- 考核形式 examForm -->
        <el-form-item :label="$t('c.examType')" v-if="nameArrays.findIndex((n) => n.key == 'examForm')>-1">
            <el-select v-model="examForm.selectVal" multiple collapse-tags :placeholder="$t('tip.select')">
                <el-option :label="$t('c.all')" :value="0"></el-option>
                <el-option :label="item.value" :value="item.id" :key="item.id" v-for="item in examFormMenu"></el-option>
            </el-select>
        </el-form-item>

        <el-form-item :label="$t('train.group')" v-if="nameArrays.findIndex((n) => n.key == 'groupType')>-1">
            <el-select v-model="groupType.selectVal" multiple collapse-tags :placeholder="$t('tip.select')">
                <el-option :label="$t('c.all')" :value="0"></el-option>
                <el-option :label="item.value" :value="item.id" :key="item.id" v-for="item in groupMenu"></el-option>
            </el-select>
        </el-form-item>

        <!-- 适用级别 forLevel -->
        <el-form-item :label=" nameArrays.find((n) => n.key == 'forLevel')['title'] || $t('c.operatorLevel')"
                    v-if="nameArrays.findIndex((n) => n.key == 'forLevel')>-1">
            <el-select v-model="forLevel.selectVal" multiple collapse-tags :placeholder="$t('tip.select')">
                <el-option :label="$t('c.all')" :value="0"></el-option>
                <el-option :label="item.value" :value="item.id" :key="item.id" v-for="item in forLevelMenu"></el-option>
            </el-select>
        </el-form-item>

        <!-- 岗位：positionType -->
        <el-form-item :label="$t('c.position')" v-if="nameArrays.findIndex((n) => n.key == 'positionType')>-1">
            <el-select v-model="positionType.selectVal" multiple collapse-tags :placeholder="$t('tip.select')">
                <el-option :label="$t('c.all')" :value="0"></el-option>
                <el-option :label="item.value" :value="item.id" :key="item.id" v-for="item in positionMenu"></el-option>
            </el-select>
        </el-form-item>

        <!-- 身份类型：userType -->
        <el-form-item :label="$t('c.occupation')" v-if="nameArrays.findIndex((n) => n.key == 'userType')>-1">
            <el-select v-model="userType.selectVal" multiple collapse-tags :placeholder="$t('tip.select')">
                <el-option :label="$t('c.all')" :value="0"></el-option>
                <el-option :label="item.value" :value="item.id" :key="item.id" v-for="item in userTypeMenu"></el-option>
            </el-select>
        </el-form-item>

        <!-- 课件类型 courseType -->
        <el-form-item :label=" nameArrays.find((n) => n.key == 'courseType')['title'] || $t('course.type')"
                    v-if="nameArrays.findIndex((n) => n.key == 'courseType')>-1">
            <el-select v-model="courseType.selectVal" multiple collapse-tags :placeholder="$t('tip.select')">
                <el-option :label="$t('c.all')" :value="0"></el-option>
                <el-option :label="item.value" :value="item.id" :key="item.id"
                        v-for="item in courseTypeMenu"></el-option>
            </el-select>
        </el-form-item>

        <!-- 考卷类型 paperType -->
        <el-form-item :label="$t('paper.type')" v-if="nameArrays.findIndex((n) => n.key == 'paperType')>-1">
            <el-select v-model="paperType.selectVal" multiple collapse-tags :placeholder="$t('tip.select')">
                <el-option :label="$t('c.all')" :value="0"></el-option>
                <el-option :label="item.value" :value="item.id" :key="item.id"
                           v-for="item in paperTypeMenu"></el-option>
            </el-select>
        </el-form-item>

        <!-- 难度 difficulty -->
        <el-form-item :label="$t('c.difficulty')" v-if="nameArrays.findIndex((n) => n.key == 'difficulty')>-1">
            <el-select v-model="difficulty.selectVal" multiple collapse-tags :placeholder="$t('tip.select')">
                <el-option :label="$t('c.all')" :value="0"></el-option>
                <el-option :label="item.value" :value="item.id" :key="item.id"
                        v-for="item in difficultyMenu"></el-option>
            </el-select>
        </el-form-item>

        <!-- 组卷方式 paperMethod -->
        <el-form-item :label="$t('paper.paperMethod')"
                    v-if="nameArrays.findIndex((n) => n.key == 'paperMethod')>-1">
            <el-select v-model="paperMethod.selectVal" multiple collapse-tags :placeholder="$t('tip.select')">
                <el-option :label="$t('c.all')" :value="0"></el-option>
                <el-option :label="item.value" :value="item.id" :key="item.id"
                        v-for="item in paperMethodMenu"></el-option>
            </el-select>
        </el-form-item>

        <!-- 题型 topicType 传onlyTheory则只有理论-->
        <el-form-item :label="$t('paper.questionType')" v-if="nameArrays.findIndex((n) => n.key == 'topicType')>-1">
            <el-select v-model="topicType.selectVal" multiple collapse-tags :placeholder="$t('tip.select')">
                <el-option :label="$t('c.all')" :value="0"></el-option>
                <el-option :label="item.value" :value="item.id" :key="item.id"
                        v-for="item in topicTypeMenu"></el-option>
            </el-select>
        </el-form-item>

        <!-- 考试状态 examStatus
            注意：因为值中有0，在active中对id+1，在组件中要-1后再发请求
        -->
        <el-form-item :label="$t('c.status')" v-if="nameArrays.findIndex((n) => n.key == 'examStatus')>-1">
            <el-select v-model="examStatus.selectVal" multiple collapse-tags :placeholder="$t('tip.select')">
                <el-option :label="$t('c.all')" :value="0"></el-option>
                <el-option :label="item.value" :value="item.id" :key="item.id" v-for="item in examStatusMenu"
                        style="width: 200px"></el-option>
            </el-select>
        </el-form-item>

        <!-- 证书类型 certTypes -->
        <el-form-item :label="$t('cert.type')" v-if="nameArrays.findIndex((n) => n.key == 'certTypes')>-1">
            <el-select v-model="certTypes.selectVal" multiple collapse-tags :placeholder="$t('tip.select')">
                <el-option :label="$t('c.all')" :value="0"></el-option>
                <el-option :label="item.value" :value="item.id" :key="item.id"
                        v-for="item in certTypesMenu"></el-option>
            </el-select>
        </el-form-item>

        <!-- 开岗放权 preJob -->
        <el-form-item :label="$t('system.preJobApproval')" v-if="nameArrays.findIndex((n) => n.key == 'preJob')>-1">
            <el-select v-model="preJob.selectVal" multiple collapse-tags :placeholder="$t('tip.select')">
                <el-option :label="$t('c.all')" :value="0"></el-option>
                <el-option :label="item.value" :value="item.id" :key="item.id" v-for="item in preJobMenu"></el-option>
            </el-select>
        </el-form-item>

        <!-- 学习统计类型 learnImageTypes -->
        <el-form-item :label="$t('c.type')" v-if="nameArrays.findIndex((n) => n.key == 'learnImageTypes')>-1">
            <el-select v-model="learnImageTypes.selectVal" multiple collapse-tags :placeholder="$t('tip.select')">
                <el-option :label="$t('c.all')" :value="0" style="width: 200px"></el-option>
                <el-option :label="item.value" :value="item.id" :key="item.id" v-for="item in learnImageTypesMenu"
                        style="width: 200px"></el-option>
            </el-select>
        </el-form-item>

        <!-- 图像视角 viewCount -->
        <el-form-item class="selector-viewCount" :label="$t('res.perspective')" v-if="nameArrays.findIndex((n) => n.key == 'viewCount')>-1">
            <el-select v-model="viewCount.selectVal" multiple collapse-tags :placeholder="$t('tip.select')">
                <el-option :label="$t('c.all')" :value="0"></el-option>
                <el-option :label="item.value" :value="item.id" :key="item.id"
                        v-for="item in viewCountMenu"></el-option>
            </el-select>
        </el-form-item>

        <!-- 图像来源 imageOrigin -->
        <el-form-item :label="$t('res.imgOrigin')" v-if="nameArrays.findIndex((n) => n.key == 'imageOrigin')>-1">
            <el-select v-model="imageOrigin.selectVal" multiple collapse-tags :placeholder="$t('tip.select')">
                <el-option :label="$t('c.all')" :value="0"></el-option>
                <el-option :label="item.value" :value="item.id" :key="item.id"
                        v-for="item in imageOriginMenu"></el-option>
            </el-select>
        </el-form-item>

        <!-- 台账来源 ledgerOrigin -->
        <el-form-item :label="$t('paper.source')" v-if="nameArrays.findIndex((n) => n.key == 'ledgerOrigin')>-1">
            <el-select v-model="ledgerOrigin.selectVal" multiple collapse-tags :placeholder="$t('tip.select')">
                <el-option :label="$t('c.all')" :value="0"></el-option>
                <el-option :label="item.value" :value="item.id" :key="item.id"
                           v-for="item in ledgerOriginMenu"></el-option>
            </el-select>
        </el-form-item>

        <!-- 年度 yearTime -->
        <el-form-item :label="$t('c.yearTime')" v-if="nameArrays.findIndex((n) => n.key == 'yearTime')>-1">
            <el-select v-model="yearTime.selectVal" multiple collapse-tags :placeholder="$t('tip.select')">
                <el-option :label="$t('c.all')" :value="0"></el-option>
                <el-option :label="item.value" :value="item.id" :key="item.id" v-for="item in yearTimeMenu"></el-option>
            </el-select>
        </el-form-item>
        <!-- 图像学习统计类型 learnImageTypes -->
        <el-form-item :label="$t('res.imgType')" v-if="nameArrays.findIndex((n) => n.key == 'imageTypes')>-1">
            <el-select v-model="imageTypes.selectVal" multiple collapse-tags :placeholder="$t('tip.select')">
                <el-option :label="$t('c.all')" :value="0" style="width: 200px"></el-option>
                <el-option :label="item.value" :value="item.id" :key="item.id" v-for="item in imageTypesMenu"
                        style="width: 200px"></el-option>
            </el-select>
        </el-form-item>
        <!-- 知识库 知识类型knowledgeType -->
        <el-form-item :label="$t('res.knowType')" v-if="nameArrays.findIndex((n) => n.key == 'knowledgeType')>-1">
            <el-select v-model="knowledgeType.selectVal" multiple collapse-tags :placeholder="$t('tip.select')">
                <el-option :label="$t('c.all')" :value="0" style="width: 200px"></el-option>
                <el-option :label="item.value" :value="item.id" :key="item.id" v-for="item in knowledgeTypeMenu"
                        style="width: 200px"></el-option>
            </el-select>
        </el-form-item>
        <!--学分类型knowledgeType -->
        <el-form-item :label="$t('c.type')" v-if="nameArrays.findIndex((n) => n.key == 'creditType')>-1">
            <el-select v-model="creditType.selectVal" multiple collapse-tags :placeholder="$t('tip.select')">
                <el-option :label="$t('c.all')" :value="0" style="width: 200px"></el-option>
                <el-option :label="item.value" :value="item.id" :key="item.id" v-for="item in creditTypeMenu"
                        style="width: 200px"></el-option>
            </el-select>
        </el-form-item>
        <!--是否职鉴图像fiscanType -->
        <el-form-item label="是否职鉴图像" v-if="nameArrays.findIndex((n) => n.key == 'fiscanType')>-1">
            <el-select v-model="fiscanTypes.selectVal" multiple collapse-tags :placeholder="$t('tip.select')">
                <el-option :label="$t('c.all')" :value="0" style="width: 200px"></el-option>
                <el-option :label="item.value" :value="item.id" :key="item.id" v-for="item in fiscanTypeMenu"
                        style="width: 200px"></el-option>
            </el-select>
        </el-form-item>
        <!--违禁品数量 -->
        <el-form-item label="设备型号" v-if="nameArrays.findIndex((n) => n.key == 'fiscanProduct')>-1">
            <el-select v-model="fiscanProduct.selectVal" multiple collapse-tags :placeholder="$t('tip.select')">
                <el-option :label="$t('c.all')" :value="0" style="width: 200px"></el-option>
                <el-option :label="item.value" :value="item.id" :key="item.id" v-for="item in fiscanProductMenu"
                        style="width: 200px"></el-option>
            </el-select>
        </el-form-item>
    </span>
</template>
<script>
    import { mapGetters } from 'vuex';
    import api from '@/api';

    export default {
        props: {
            nameArrays: {
                type: Array,
                required: true
            },
            isSelected: {
                selected: Array
            }
        },
        data() {
            return {
                trainType: {
                    selectVal: [],
                },
                trainMode: {
                    selectVal: [],
                },
                examForm: {
                    selectVal: [],
                },
                groupType: {
                    selectVal: [],
                },
                forLevel: {
                    selectVal: [],
                },
                positionType: {
                    selectVal: [],
                },
                userType: {
                    selectVal: [],
                },
                courseType: {
                    selectVal: [],
                },
                paperType: {
                    selectVal: [],
                },
                difficulty: {
                    selectVal: [],
                },
                paperMethod: {
                    selectVal: [],
                },
                topicType: {
                    selectVal: [],
                },
                examStatus: {
                    selectVal: [],
                },
                certTypes: {
                    selectVal: [],
                },
                preJob: {
                    selectVal: [],
                },
                learnImageTypes: {
                    selectVal: [],
                },
                learnImageTypesMenu: [
                    {
                        value: 'CT',
                        id: 'CT'
                    }, {
                        value: 'DR',
                        id: 'DR'
                    }
                ],
                imageTypes: {
                    selectVal: [],
                },
                imageTypesMenu: [
                    {
                        value: 'CT',
                        id: '3'
                    }, {
                        value: 'DR',
                        id: '4'
                    }
                ],
                viewCount: {
                    selectVal: []
                },
                imageOrigin: {
                    selectVal: [],
                },
                ledgerOrigin: {
                    selectVal: [],
                },
                projectType: {
                    selectVal: [],
                },
                yearTime: {
                    selectVal: [],
                },
                knowledgeType: {
                    selectVal: [],
                },
                creditType: {
                    selectVal: [],
                },
                fiscanTypes: {
                    selectVal: [],
                },
                fiscanTypeMenu: [
                    {
                        value: '是',
                        id: '1'
                    }, {
                        value: '否',
                        id: '2'
                    }
                ],
                tipCounts: {
                    selectVal: [],
                },
                tipCountMenu: [
                    {
                        value: '1',
                        id: '1'
                    }, {
                        value: '2',
                        id: '2'
                    }, {
                        value: '3',
                        id: '3'
                    }
                ],
                fiscanProduct: {
                    selectVal: [],
                },
            }
        },
        mounted() {
            this.nameArrays.forEach((item, index) => {
                switch (item.key) {
                    case "trainType":
                        this.$store.dispatch('getTrainTypeMenu')
                        break;
                    case "trainMode":
                        this.$store.dispatch('getTrainModeMenu')
                        break;
                    case "examForm":
                        this.$store.dispatch('getExamFormMenu')
                        break;
                    case "groupType":
                        this.$store.dispatch('getGroupMenu');
                        break;
                    case "forLevel":
                        this.$store.dispatch('getForLevelMenu')
                        break;
                    case "positionType":
                        this.$store.dispatch('getPositionMenu')
                        break;
                    case "userType":
                        this.$store.dispatch('getUserTypeMenu')
                        break;
                    case "courseType":
                        this.$store.dispatch('getCourseTypeMenu')
                        break;
                    case "paperType":
                        this.$store.dispatch('getPaperTypeMenu')
                        break;
                        break;
                    case "difficulty":
                        this.$store.dispatch('getDifficultyMenu')
                        break;
                    case "paperMethod":
                        this.$store.dispatch('getPaperMethodMenu')
                        break;
                    case "topicType":
                        this.$store.dispatch('getTopicTypeMenu').then(v => {
                            if (item.onlyTheory) {
                                let arr = v.filter(obj => {
                                    return (obj.value !== 'CT') && (obj.value !== 'DR')
                                })
                                this.$store.commit('getTopicTypeMenu', arr)
                            } else {
                                this.$store.commit('getTopicTypeMenu', v)
                            }
                            //this.topicType.selectVal = [0, ...this.topicTypeMenu.map(item => item.id)]
                        });
                        break;
                    case "examStatus":
                        this.$store.dispatch('getExamStatusMenu')
                        break;
                    case "certTypes":
                        this.$store.dispatch('getCertTypesMenu')
                        break;
                    case "preJob":
                        this.$store.dispatch('getPreJobMenu')
                        break;
                    case "learnImageTypes":
                        break;
                    case "imageTypes":
                        break;
                    case "viewCount":
                        this.$store.dispatch('getViewCountMenu')
                        break;
                    case "imageOrigin":
                        this.$store.dispatch('getImageOriginMenu')
                        break;
                    case "ledgerOrigin":
                        this.$store.dispatch('getLedgerOriginMenu')
                        break;
                    case "projectType":
                        this.$store.dispatch('getProjectTypeMenu')
                        break;
                    case "knowledgeType":
                        this.$store.dispatch('getKnowledgeTypeMenu')
                        break;
                    case "creditType":
                        this.$store.dispatch('getCreditTypeMenu')
                        break;
                    case "yearTime":
//                        this.$store.dispatch('getYearTimeMenu')
                        break;
                    case "fiscanType":
                        break;
                    case "tipCount":
                        break;
                    case "fiscanProduct":
                        this.$store.dispatch('getFiscanProductMenu')
                        break;
                    default:
                        console.error("传错了值，请检查拼写")
                }
            })

        },
        computed: {
            ...mapGetters([
                'trainTypeMenu',
                'trainModeMenu',
                'examFormMenu',
                'forLevelMenu',
                'groupMenu',
                'positionMenu',
                'userTypeMenu',
                'courseTypeMenu',
                'paperTypeMenu',
                'difficultyMenu',
                'paperMethodMenu',
                'topicTypeMenu',
                'examStatusMenu',
                'certTypesMenu',
                'preJobMenu',
                'viewCountMenu',
                'imageOriginMenu',
                'ledgerOriginMenu',
                'projectTypeMenu',
                'knowledgeTypeMenu',
                'creditTypeMenu',
                'fiscanTypeMenu',
                'tipCountMenu',
                'fiscanProductMenu',
            ]),

            yearTimeMenu() {
                var myDate = new Date();
                var nowYear = myDate.getFullYear();//起始年份
                var lastYear = myDate.getFullYear() - 9;//结束年份
                let years = []
                for (var i = lastYear; i <= nowYear; i++) {
                    years.push({ id: i, value: i + '年' });
                }
                return years.reverse()
            }
        },
        watch: {
            'trainType.selectVal'(val, oldVal) {
                this.handler(val, oldVal, {
                    item: this.trainType,
                    menu: this.trainTypeMenu,
                    callback: 'getTrainTypeVal'
                });
            },
            'trainMode.selectVal'(val, oldVal) {
                this.handler(val, oldVal, {
                    item: this.trainMode,
                    menu: this.trainModeMenu,
                    callback: 'getTrainModeVal'
                });
            },
            'examForm.selectVal'(val, oldVal) {
                this.handler(val, oldVal, {
                    item: this.examForm,
                    menu: this.examFormMenu,
                    callback: 'getExamFormVal'
                });
            },
            'groupType.selectVal'(val, oldVal) {
                this.handler(val, oldVal, {
                    item: this.groupType,
                    menu: this.groupMenu,
                    callback: 'getGroupTypeVal'
                });
            },
            'forLevel.selectVal'(val, oldVal) {
                this.handler(val, oldVal, {
                    item: this.forLevel,
                    menu: this.forLevelMenu,
                    callback: 'getForLevelVal'
                });
            },
            'positionType.selectVal'(val, oldVal) {
                this.handler(val, oldVal, {
                    item: this.positionType,
                    menu: this.positionMenu,
                    callback: 'getPositionTypeVal'
                });
            },
            'userType.selectVal'(val, oldVal) {
                this.handler(val, oldVal, {
                    item: this.userType,
                    menu: this.userTypeMenu,
                    callback: 'getUserTypeVal'
                });
            },
            'courseType.selectVal'(val, oldVal) {
                this.handler(val, oldVal, {
                    item: this.courseType,
                    menu: this.courseTypeMenu,
                    callback: 'getCourseTypeVal'
                });
            },
            'paperType.selectVal'(val, oldVal) {
                this.handler(val, oldVal, {
                    item: this.paperType,
                    menu: this.paperTypeMenu,
                    callback: 'getPaperTypeVal'
                });
            },
            'difficulty.selectVal'(val, oldVal) {
                this.handler(val, oldVal, {
                    item: this.difficulty,
                    menu: this.difficultyMenu,
                    callback: 'getDifficultyVal'
                });
            },
            'paperMethod.selectVal'(val, oldVal) {
                this.handler(val, oldVal, {
                    item: this.paperMethod,
                    menu: this.paperMethodMenu,
                    callback: 'getPaperMethodVal'
                });
            },
            'topicType.selectVal'(val, oldVal) {
                this.handler(val, oldVal, {
                    item: this.topicType,
                    menu: this.topicTypeMenu,
                    callback: 'getTopicTypeVal'
                });
            },
            'examStatus.selectVal'(val, oldVal) {
                this.handler(val, oldVal, {
                    item: this.examStatus,
                    menu: this.examStatusMenu,
                    callback: 'getExamStatusVal'
                });
            },
            'certTypes.selectVal'(val, oldVal) {
                this.handler(val, oldVal, {
                    item: this.certTypes,
                    menu: this.certTypesMenu,
                    callback: 'getCertTypesVal'
                });
            },
            'preJob.selectVal'(val, oldVal) {
                this.handler(val, oldVal, {
                    item: this.preJob,
                    menu: this.preJobMenu,
                    callback: 'getPreJobVal'
                });
            },
            'learnImageTypes.selectVal'(val, oldVal) {
                this.handler(val, oldVal, {
                    item: this.learnImageTypes,
                    menu: this.learnImageTypesMenu,
                    callback: 'learnImageTypesVal'
                });
            },
            'imageTypes.selectVal'(val, oldVal) {
                this.handler(val, oldVal, {
                    item: this.imageTypes,
                    menu: this.imageTypesMenu,
                    callback: 'imageTypesVal'
                });
            },
            'viewCount.selectVal'(val, oldVal) {
                this.handler(val, oldVal, {
                    item: this.viewCount,
                    menu: this.viewCountMenu,
                    callback: 'getViewCountVal'
                });
            },
            'imageOrigin.selectVal'(val, oldVal) {
                this.handler(val, oldVal, {
                    item: this.imageOrigin,
                    menu: this.imageOriginMenu,
                    callback: 'getImageOriginVal'
                });
            },
            'ledgerOrigin.selectVal'(val, oldVal) {
                this.handler(val, oldVal, {
                    item: this.ledgerOrigin,
                    menu: this.ledgerOriginMenu,
                    callback: 'getLedgerOriginVal'
                });
            },
            'projectType.selectVal'(val, oldVal) {
                this.handler(val, oldVal, {
                    item: this.projectType,
                    menu: this.projectTypeMenu,
                    callback: 'getProjectTypeVal'
                });
            },
            'knowledgeType.selectVal'(val, oldVal) {
                this.handler(val, oldVal, {
                    item: this.knowledgeType,
                    menu: this.knowledgeTypeMenu,
                    callback: 'getKnowledgeTypeVal'
                });
            },
            'creditType.selectVal'(val, oldVal) {
                this.handler(val, oldVal, {
                    item: this.creditType,
                    menu: this.creditTypeMenu,
                    callback: 'getCreditTypeVal'
                });
            },
            'yearTime.selectVal'(val, oldVal) {
                this.handler(val, oldVal, {
                    item: this.yearTime,
                    menu: this.yearTimeMenu,
                    callback: 'getYearTimeVal'
                });
            },
            'fiscanTypes.selectVal'(val, oldVal) {
                this.handler(val, oldVal, {
                    item: this.fiscanTypes,
                    menu: this.fiscanTypeMenu,
                    callback: 'getFiscanTypeVal'
                });
            },
            'tipCounts.selectVal'(val, oldVal) {
                this.handler(val, oldVal, {
                    item: this.tipCounts,
                    menu: this.tipCountMenu,
                    callback: 'getTipCountVal'
                });
            },
            'fiscanProduct.selectVal'(val, oldVal) {
                this.handler(val, oldVal, {
                    item: this.fiscanProduct,
                    menu: this.fiscanProductMenu,
                    callback: 'getFiscanProductVal'
                });
            },
        },
        methods: {
            handler(val, oldVal, dropObj) {
                if (Math.abs(val.length - oldVal.length) === 1) {

                    // a. 当前值中有全选
                    if (val.includes(0)) {
                        // a1 点击的是全选 => 选中所有值
                        if (!oldVal.includes(0)) {
                            dropObj.item.selectVal = [0, ...dropObj.menu.map(item => item.id)]
                            // a2 点击的是某个值 => (取消当前值) && 取消全选
                        } else if (val.length < oldVal.length) {
                            dropObj.item.selectVal.splice(dropObj.item.selectVal.indexOf(0), 1)
                        }

                        // b. 当前值中无全选
                    } else {
                        // b1 点击的是全选 => 取消所有值
                        if (oldVal.includes(0)) {
                            dropObj.item.selectVal = []
                            // 点击的是某个值 => (选中当前值)
                        } else {
                            // 判断是否全部都选了
                            if (val.length === dropObj.menu.length) {
                                dropObj.item.selectVal = [0, ...val]
                            }
                        }
                    }
                }
                this.$emit(dropObj.callback, dropObj.item.selectVal);
            },

            reset() {
                Object.assign(this.$data, this.$options.data())
            }
        }
    }
</script>
<style lang="scss">
    @import '../style/const.scss';
</style>
